var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYuchenBackgroundEl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 582.24 539.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea656e;}.cls-2{fill:#f8dde1;}.cls-3{fill:none;stroke:#f6d5d8;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "yuchen_backgroundEl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 312.55,
    cy: 269.68,
    r: 269.68
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "leaves_back",
    "data-name": "leaves back"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.11,455.49c-25.29-34.53-49.44-80-32.34-95.63,13.46-12.27,32.93-7.54,45.05,29,8.28,25,58.18,126.68,71.5,151.12C379.32,540,335.2,510.24,295.11,455.49Z",
    transform: "translate(-231.18 -127.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M414,300.93c-.06-9.17-9.18-34.11-18.51-28.79-14,6.93-19.55,27-19.79,41.37-.62,37.18,27.43,122.94,31.18,107.43C416.39,381.76,418.17,340.49,414,300.93Z",
    transform: "translate(-231.18 -127.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.18,334.41c-1.62-3.19-3.05-6.65-2.76-10.21s2.86-7.16,6.42-7.49a8.51,8.51,0,0,1,6.31,2.57c4.54,4.21,5.87,10.78,6.62,16.92,1,7.73,2.14,16.36,1.33,24.05C337.5,352.09,331,343.81,326.18,334.41Z",
    transform: "translate(-231.18 -127.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.27,291.88c-2-3.12-4.42-6.15-7.8-7.61s-7.9-.84-9.94,2.23a8.2,8.2,0,0,0-.44,7.37,20.41,20.41,0,0,0,4.34,6.26,85.48,85.48,0,0,0,11.7,10.47c3.76,2.77,10.5,11.23,11.89,15.95C353,315.81,348.16,301.15,342.27,291.88Z",
    transform: "translate(-231.18 -127.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M439.37,262c2,1.18,2.69,7.49.74,14.56-1.74,6.32-5.76,14.15-8.27,24.92,0,0-5.85-13.49-4.89-23.17C428.15,266.08,433.39,258.35,439.37,262Z",
    transform: "translate(-231.18 -127.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.29,380.67c-2-2-9-8.7-13.81-3.31-1.92,2.14-1.59,7.32,9,12.1,4.66,2.11,15.32,7.66,15.32,7.66S377.25,386.63,371.29,380.67Z",
    transform: "translate(-231.18 -127.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.58,523.68c-8-1.52-19.66-5-28.09,2.18-4.68,4-7.12,12.95,1,16.79,13.52,6.37,41.64-6.14,53.42-12.48C290.93,530.17,276,525.86,264.58,523.68Z",
    transform: "translate(-231.18 -127.44)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYuchenBackgroundEl);
export default __webpack_public_path__ + "static/media/yuchen_backgroundEl.81040346b8fb2601fbefa08256380724.svg";
export { ForwardRef as ReactComponent };